module.exports = __webpack_public_path__ + "assets/img/slat_open5.16dd3e73.svg";